 <script>

import { createEventDispatcher } from 'svelte';
     
import {Input, Button} from '../components/ui';
import {getWebsiteInfos, getHomepageScreenshot, getHomepageText} from '../helper/PostHelper';

export let url;
let className = '';

let waiting = false;

export {className as class};

const dispatch = createEventDispatcher();

function dataReceived(res) {
    dispatch('message', res);
}
    
let extractions = null;
    const getWebsite = ()=>{
        waiting = true;
        // let waitingForHomepage = true;
        // let waitingForInfo = true;
        // getWebsiteInfos(model.url).then((res)=>{
        //     model.extractions = res.extractions;
        //     waitingForInfo = false;
        //      waiting = waitingForInfo && waitingForHomepage;
        // });
    
        // getHomepageScreenshot(model.url).then((res)=>{     
        //     waitingForHomepage = false;    
        //     waiting = waitingForInfo && waitingForHomepage;    
        //     model.screenshots = [...model.screenshots, res];
        // })
        getHomepageText(url).then((res)=>{
            console.log(res);
            waiting = false;
            dataReceived(res.data);
        })
    } 


    // let clearbitHomapage = null;
    // const onHomepageBlur = () =>{
    //     console.log( model.homepage);
    //     clearbitHomapage = `https://logo.clearbit.com/${model.homepage}`
    //     model = model;
    // }
 </script>
 
 <div class="{className}">
    <Input bind:model={url} label='Website' class="mt-4 mb-4"/>
    {#if waiting == false}
    <Button on:submit={getWebsite} primary={true}>Get Data</Button>
    {:else}
    <p>Building up data</p>
    {/if}
</div> 
            <!-- <input bind:value={model.homepage} on:blur={onHomepageBlur} />
        {#if clearbitHomapage != null}
            <Image bind:src={clearbitHomapage} isExternal={true} />
        {/if} -->
        <!-- <input bind:value={model.homepage} on:blur={getWebsite} /> -->